<!-- Sensitivity labels -->
<button matButton
        type="button"
        #tooltip="matTooltip"
        [matTooltipPosition]="btnTooltipPosition()"
        matTooltip="Apply a sensitivity label to your content to keep it compliant with your organization's information protection policies."
        aria-label="Apply a sensitivity label to your content to keep it compliant with your organization's information protection policies."
        [matMenuTriggerFor]="categories">
  @let icon = (sensitivityLabel.id !== 0) ? 'shield' : 'gpp_maybe';
  @let label = (sensitivityLabel.id !== 0) ? sensitivityLabel.label : 'Sensitivity label';

  <mat-icon class="material-symbols-outlined" [fontIcon]="icon"/>
  {{ label }}
  <mat-icon iconPositionEnd fontIcon="expand_more"/>
</button>

<mat-menu #categories>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Non-work-related information owned by members should be labeled as Personal."
          aria-label="Non-work-related information owned by members should be labeled as Personal."
          (click)="onSelectSensitivity(1)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    Personal
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="This information is not sensitive and requires no protection. There are no adverse effects to CGIF if public information is disclosed."
          aria-label="This information is not sensitive and requires no protection. There are no adverse effects to CGIF if public information is disclosed."
          (click)="onSelectSensitivity(2)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    Public
  </button>
  <button mat-menu-item type="button" [matMenuTriggerFor]="internal">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Internal
  </button>
  <button mat-menu-item type="button" [matMenuTriggerFor]="conf">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Confidential
  </button>
  <button mat-menu-item type="button" [matMenuTriggerFor]="highlyConf">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Highly Confidential
  </button>
  <button mat-menu-item type="button" [matMenuTriggerFor]="cui">
    <mat-icon class="material-symbols-outlined red-shield" [style.color]="'#7D0D1E'" fontIcon="safety_check_off"/>
    CUI
  </button>
</mat-menu>

<mat-menu #internal="matMenu">
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals."
          aria-label="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals."
          (click)="onSelectSensitivity(4)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Internal
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals, and will be shared with a Third Party."
          aria-label="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals, and will be shared with a Third Party."
          (click)="onSelectSensitivity(5)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    Third Party
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          aria-label="Information for which an unauthorized disclosure could have a limited adverse effect on CGIF operations, organizational assets, or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          (click)="onSelectSensitivity(6)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGI Parent & Affiliate
  </button>
</mat-menu>
<mat-menu #conf="matMenu">
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals."
          aria-label="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals."
          (click)="onSelectSensitivity(8)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Confidential
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals, and will be shared with a Third Party."
          aria-label="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals, and will be shared with a Third Party."
          (click)="onSelectSensitivity(9)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    Third Party
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          aria-label="Information for which an unauthorized disclosure could cause a serious adverse effect on organizational operations, organizational assets or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          (click)="onSelectSensitivity(10)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGI Parent & Affiliate
  </button>
</mat-menu>
<mat-menu #highlyConf="matMenu">
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals."
          aria-label="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals."
          (click)="onSelectSensitivity(12)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGIF - Highly Confidential
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals, and will be shared with a Third Party."
          aria-label="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals, and will be shared with a Third Party."
          (click)="onSelectSensitivity(13)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    Third Party
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          aria-label="Information for which an unauthorized disclosure can have a severe or catastrophic adverse effect on organizational operations, organizational assets or individuals, and will be shared with a CGI Parent and Affiliate.  For questions about information that requires a FOCI Release Determination, please contact Industrial Security (cgifederalsecurity@cgifederal.com)."
          (click)="onSelectSensitivity(14)">
    <mat-icon class="material-symbols-outlined" fontIcon="shield"/>
    CGI Parent & Affiliate
  </button>
</mat-menu>
<mat-menu #cui="matMenu">
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="CUI labels should only be used when the data has been identified as such by the client (includes FOUO, SBU, etc.)"
          aria-label="CUI labels should only be used when the data has been identified as such by the client (includes FOUO, SBU, etc.)"
          (click)="onSelectSensitivity(16)" disabled>
    <mat-icon class="material-symbols-outlined red-shield" [style.color]="'#7D0D1E'" fontIcon="safety_check_off"/>
    CUI
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Information may not be disseminated in any form to foreign governments, foreign nationals, foreign or international organizations, or non-U.S. citizens."
          aria-label="Information may not be disseminated in any form to foreign governments, foreign nationals, foreign or international organizations, or non-U.S. citizens."
          (click)="onSelectSensitivity(17)" disabled>
    <mat-icon class="material-symbols-outlined red-shield" [style.color]="'#7D0D1E'" fontIcon="safety_check_off"/>
    NOFORN
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Includes individuals or employees who enter into a contract with the U.S. to perform a specific job, supply labor and materials, or for the sale of products and services, so long as dissemination is in furtherance of the contractual purpose."
          aria-label="Includes individuals or employees who enter into a contract with the U.S. to perform a specific job, supply labor and materials, or for the sale of products and services, so long as dissemination is in furtherance of the contractual purpose."
          (click)="onSelectSensitivity(18)" disabled>
    <mat-icon class="material-symbols-outlined red-shield" [style.color]="'#7D0D1E'" fontIcon="safety_check_off"/>
    FEDCON
  </button>
  <button mat-menu-item type="button" #tooltip="matTooltip" matTooltipPosition="right"
          matTooltip="Dissemniation authorized only to those individuals, organizations, or entities included on an accompanying dissemination list."
          aria-label="Dissemniation authorized only to those individuals, organizations, or entities included on an accompanying dissemination list."
          (click)="onSelectSensitivity(19)" disabled>
    <mat-icon class="material-symbols-outlined red-shield" [style.color]="'#7D0D1E'" fontIcon="safety_check_off"/>
    DL ONLY
  </button>
</mat-menu>
<!-- END: Sensitivity labels -->
